import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import './details.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCode, faGlobe, faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'
import { project_data } from '../../data/projects_data'
import { motion } from 'framer-motion'
import NumberCounter from 'react-countup';


// import { LazyLoadImage } from 'react-lazy-load-image-component'
// import 'react-lazy-load-image-component/src/effects/blur.css'

import { faCode } from '@fortawesome/free-solid-svg-icons'
const Details = () => {
  const containerRef = useRef(null);
  const [iconsize, seticonchange] = useState(() => {
    return window.innerWidth <= 500 ? 'xl' : '2xl';
  });

  useEffect(() => {


    const handleResize = () => {
      seticonchange(window.innerWidth <= 500 ? 'xl' : '2xl');
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [divClicked, setdivClicked] = useState(false)
  const [projIndexvalue, setprojIndexvalue] = useState(0);

  const setIndexvalue = (pro_indx) => {
    setprojIndexvalue(pro_indx)
    setdivClicked(true)

  }

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += 300;
    };
  }
  const scrollLeft = () => {
    console.log('ggg')
    if (containerRef.current) {
      containerRef.current.scrollLeft -= 200;
    }
  };

const [popupVisible, setPopupVisible] = useState(false);
const [popupContent, setPopupContent] = useState(null);

const openPopup = (content) => {
  console.log('clicked')
  setPopupContent(content);
  setPopupVisible(true);
};



  return (
    <div className='maindetails'>
      <div className="details_info">
        <span>... </span>
        <span className='stroke-text'>What I Am Great At</span>
        <div className="detail">
          <span>Explore our projects and services by clicking below! Feel free to dive into our work and utilize our offerings. Don't forget to check out our GitHub repository for code. We welcome your feedback and suggestions to help improve our projects</span>
        </div>
      </div>

      {divClicked && (
        <motion.div
          initial={{ scale: 0.7, opacity: 0, filter: 'blur(5px)' }}

          whileInView={{ scale: 1, opacity: 1, filter: 'blur(0px)' }}
          transition={{ duration: 1.5 }}
          className="bckdiv">

          <div className="bckdiv-wrapper">
            <div className='exit_icon' onClick={() => setdivClicked(false)}><FontAwesomeIcon icon={faCircleXmark} size="xl" /></div>

            <div id="scrollRight" className='rightarrow' onClick={scrollRight}><FontAwesomeIcon icon={faArrowRight} size='xl' /></div>

            <div id='scrollLeft' className='leeft' onClick={scrollLeft}><FontAwesomeIcon icon={faArrowLeft} size='xl' /></div>

            <div className="bckbx" ref={containerRef}>
              <div className={projIndexvalue === 3 ? 'langcls-tech' : 'sectn'}>
                {projIndexvalue === 3 ? (
                  <div className="tech-lang-container">
                    <h3 className="tech-lang-title">Skills & Technologies</h3>
                    <div className="tech-skills-grid">
                      <div className="tech-skill-card">
                        <div className="skill-info">
                          <span className="skill-name">Python</span>
                          <span className="skill-rate">Advanced</span>
                        </div>
                        <div className="skill-bar"><div className="skill-fill" style={{width: '90%'}}></div></div>
                      </div>
                      
                      <div className="tech-skill-card">
                        <div className="skill-info">
                          <span className="skill-name">Machine Learning</span>
                          <span className="skill-rate">Intermediate</span>
                        </div>
                        <div className="skill-bar"><div className="skill-fill" style={{width: '75%'}}></div></div>
                      </div>
                      <div className="tech-skill-card">
                        <div className="skill-info">
                          <span className="skill-name">C++</span>
                          <span className="skill-rate">Intermediate</span>
                        </div>
                        <div className="skill-bar"><div className="skill-fill" style={{width: '60%'}}></div></div>
                      </div>

                      <div className="tech-skill-card">
                        <div className="skill-info">
                          <span className="skill-name">Cython</span>
                          <span className="skill-rate">Familiar</span>
                        </div>
                        <div className="skill-bar"><div className="skill-fill" style={{width: '40%'}}></div></div>
                      </div>
                    </div>
                  </div>
                )
                  :
                  (project_data[projIndexvalue].map((proj, i) => (                  
                    <div onClick={() => openPopup(proj)} className={`pro_name_des ${i === 0 ? 'malegap' : ''}`} key={i}>

                      <div ><img src={proj.pro_img} />
                      </div>
                      <div  >
                        <span className='pro_name'>{proj.pro_name}</span>
                        <span className='proj_des'>{proj.pro_des}</span>

                      </div>
                    </div>
                  )))}
              </div>
            </div>
          </div></motion.div>

      )}

      <div className={`wrk ${divClicked ? 'wrk_hide' : ''}`}>
        <div className="box wrk_one pro_data_one" onClick={() => setIndexvalue(0)} >
          <div className="container1">
            <FontAwesomeIcon icon={faGlobe} fade size={iconsize} />
          </div>
          <span>
            IOT/ELE
          </span>
          <span>
            4+ Works
          </span>
        </div>
        <div className="box wrk_one pro_data_two"
          onClick={() => setIndexvalue(1)}>
          <div className="container1">
            <FontAwesomeIcon icon={faLaptopCode} fade size={iconsize} />
          </div>
          <span>
            AI/ML
          </span>
          <span>
            6+ Projects
          </span>
        </div>
        <div className="box wrk_one" onClick={() => setIndexvalue(2)}>
          <div className="container1">
            <FontAwesomeIcon icon={faCode} beatFade size={iconsize} />
          </div>
          <span>
            Web Design
          </span>
          <span>
            4+ Projects
          </span>
        </div>
        <div className="box wrk_one" onClick={() => setIndexvalue(3)}>
          <div className="container1">
            <FontAwesomeIcon icon={faFileCode} beatFade size={iconsize} />
          </div>
          <span>
            Pro-Lang
          </span>
          <span>
            4 Languages
          </span>
        </div>

      </div>
      <div className="details-data">
        <div className="expr">
          <div>
            <span>+</span>
            <span>1</span>
          </div>
          <span>Experince</span>
        </div>
        <div className="expr">
          <div>
            <span><NumberCounter end={20} start={8} delay='2' /></span>
            <span>+</span>
          </div>
          <span>Projects</span>
        </div>
        <div className="expr">
          <div>
            <span><NumberCounter end={8} start={2} delay='2' /></span>
            <span>+</span>
          </div>
          <span>Work</span>
        </div>
        <div className="expr">
          <div>
            <span><NumberCounter end={0} start={0} delay='2' /></span>
            <span></span>
          </div>
          <span>---</span>
        </div>
      </div>
      <div className=" detilblr blur"></div>

      {/* </div> */}

{popupVisible && ReactDOM.createPortal(
  <div className="popup-overlay" onClick={() => setPopupVisible(false)}>
    <div className="tech-popup-content" onClick={(e) => e.stopPropagation()}>
      <div className="tech-popup-header">
        <h3>{popupContent?.pro_name}</h3>
        <button className="tech-close-btn" onClick={() => setPopupVisible(false)}>
          <FontAwesomeIcon icon={faCircleXmark} />
        </button>
      </div>
      <div className="tech-popup-body">
        <div className="tech-popup-img-container">
          {popupContent?.pro_img && <img src={popupContent.pro_img} alt={popupContent.pro_name} />}
        </div>
        <p>{popupContent?.pro_des}</p>
      </div>
      <div className="tech-popup-actions">
        {popupContent?.proj_link && (
          <button className="tech-action-btn primary" onClick={() => window.open(popupContent.proj_link, '_blank')}>
            <FontAwesomeIcon icon={faGlobe} /> Live Demo
          </button>
        )}
        {(popupContent?.proj_docs || true) && (
           <button className="tech-action-btn secondary" onClick={() => window.open(popupContent?.proj_docs || '#', '_blank')}>
             <FontAwesomeIcon icon={faFileCode} /> Source / Docs
           </button>
        )}
      </div>
    </div>
  </div>,
  document.body
)}

    </div>
  )
}

export default Details